export const timezone = [
    {
        value: "-12:00",
        text: "UTC-12:00"
    },
    {
        value: "-11:00",
        text: "UTC-11:00"
    },
    {
        value: "-10:00",
        text: "UTC-10:00"
    },
    {
        value: "-9:00",
        text: "UTC-9:00"
    },
    {
        value: "-8:00",
        text: "UTC-8:00"
    },
    {
        value: "-7:00",
        text: "UTC-7:00"
    },
    {
        value: "-6:00",
        text: "UTC-6:00"
    },
    {
        value: "-5:00",
        text: "UTC-5:00"
    },
    {
        value: "-4:30",
        text: "UTC-4:30"
    },
    {
        value: "-4:00",
        text: "UTC-4:00"
    },
    {
        value: "-3:30",
        text: "UTC-3:30"
    },
    {
        value: "-3:00",
        text: "UTC-3:00"
    },
    {
        value: "-2:00",
        text: "UTC-2:00"
    },
    {
        value: "-1:00",
        text: "UTC-1:00"
    },
    {
        value: "+0:00",
        text: "UTC+0:00"
    },
    {
        value: "+1:00",
        text: "UTC+1:00"
    },
    {
        value: "+2:00",
        text: "UTC+2:00"
    },
    {
        value: "+3:00",
        text: "UTC+3:00"
    },
    {
        value: "+3:30",
        text: "UTC+3:30"
    },
    {
        value: "+4:00",
        text: "UTC+4:00"
    },
    {
        value: "+4:30",
        text: "UTC+4:30"
    },
    {
        value: "+5:00",
        text: "UTC+5:00"
    },
    {
        value: "+5:30",
        text: "UTC+5:30"
    },
    {
        value: "+5:45",
        text: "UTC+5:45"
    },
    {
        value: "+6:00",
        text: "UTC+6:00"
    },
    {
        value: "+6:30",
        text: "UTC+6:30"
    },
    {
        value: "+7:00",
        text: "UTC+7:00"
    },
    {
        value: "+8:00",
        text: "UTC+8:00"
    },
    {
        value: "+9:00",
        text: "UTC+9:00"
    },
    {
        value: "+9:30",
        text: "UTC+9:30"
    },
    {
        value: "+10:00",
        text: "UTC+10:00"
    },
    {
        value: "+11:00",
        text: "UTC+11:00"
    },
    {
        value: "+12:00",
        text: "UTC+12:00"
    },
    {
        value: "+13:00",
        text: "UTC+13:00"
    }
];


// WEBPACK FOOTER //
// ./src/constants/timezones.js